var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66683 15.3789C3.90016 15.3789 0.833496 12.3122 0.833496 8.54558C0.833496 4.77891 3.90016 1.71224 7.66683 1.71224C11.4335 1.71224 14.5002 4.77891 14.5002 8.54558C14.5002 12.3122 11.4335 15.3789 7.66683 15.3789ZM7.66683 2.71224C4.44683 2.71224 1.8335 5.33224 1.8335 8.54558C1.8335 11.7589 4.44683 14.3789 7.66683 14.3789C10.8868 14.3789 13.5002 11.7589 13.5002 8.54558C13.5002 5.33224 10.8868 2.71224 7.66683 2.71224Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 16.0456C14.54 16.0456 14.4133 15.9989 14.3133 15.8989L12.98 14.5656C12.7866 14.3722 12.7866 14.0522 12.98 13.8589C13.1733 13.6656 13.4933 13.6656 13.6866 13.8589L15.02 15.1922C15.2133 15.3856 15.2133 15.7056 15.02 15.8989C14.92 15.9989 14.7933 16.0456 14.6666 16.0456Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDark);
export default __webpack_public_path__ + "static/media/search-dark.822f93b677e3f474471847337522519e.svg";
export { ForwardRef as ReactComponent };